// ── Tikab Design Tokens ──────────────────────────────────────────────────────
// Enda platsen för färger och glassmorphism-stilar. Inga hex-värden i komponent.

export const colors = {
  cream:    '#F2EDE4',   // ljus bakgrund
  black:    '#1A1208',   // mörk bakgrund / text
  amber:    '#C4782A',   // diagramfärg, inre glöd
  orange:   '#E05A00',   // siffror, etiketter, accent
  white:    '#FFFFFF',
  darkText: '#1A1208',
};

// Glassmorphism-paneler – Apple-känsla
export const glass = {
  // Mörk halvtransparent panel (på mörk bakgrundsbild)
  dark: {
    background: 'rgba(10, 6, 2, 0.52)',
    backdropFilter: 'blur(24px) saturate(180%)',
    WebkitBackdropFilter: 'blur(24px) saturate(180%)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: '14px',
  },
  // Ljus halvtransparent panel (på ljus bakgrundsbild)
  light: {
    background: 'rgba(242, 237, 228, 0.60)',
    backdropFilter: 'blur(24px) saturate(180%)',
    WebkitBackdropFilter: 'blur(24px) saturate(180%)',
    border: '1px solid rgba(255,255,255,0.40)',
    borderRadius: '14px',
  },
  // Solid-glass för key-statements (opak, tydlig kontrast)
  solid: {
    background: 'rgba(12, 8, 4, 0.88)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '12px',
  },
};

// Tikab-font
export const fontFamily = "'Barlow', system-ui, -apple-system, sans-serif";
